import React, {useEffect, useRef, useState} from "react";
import {Button, Pagination, Spin} from "antd";
import PropTypes from "prop-types";

import CommentList from "../../components/comment/CommentList";
import Editor from "../../components/Editor";
import {addComment, getComments} from "../../helpers/comment";
import {messageType, showMessages} from "../../helpers/message";

import "./Comments.less";

const Comments = ({commentableType, commentableID}) => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);
    const [loading, setLoading] = useState(false);

    const [comments, setComments] = useState([]);
    const [showCommentEditor, setShowCommentEditor] = useState(false);
    const [data, setData] = useState(undefined);
    const [refreshComments, setRefreshComments] = useState(false);

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [total, setTotal] = useState(10);

    const onClickAddComment = () => {
        setShowCommentEditor(true);
    }

    const onEditorCancel = () => {
        setShowCommentEditor(false);
        setData(undefined);
    }

    const onEditorChange = (data) => {
        setData(data);
    }

    const onEditorSubmit = async () => {
        const abortSignal = abortSignalRef.current;

        setLoading(true);
        if (data) setShowCommentEditor(false);

        try {
            await addComment(
                {
                  commentableType: commentableType,
                  commentableID: commentableID,
                  text: data
                },
                abortSignal
            );
            setData(undefined);
            setRefreshComments(true);
            setLoading(false);
            setPage(1);
        } catch (error) {
            showMessages(error.message, messageType.error);
            setShowCommentEditor(true);
            setLoading(false);
        }
    }

    useEffect(() => {
        const abortSignal = abortSignalRef.current;
        setLoading(true);

        const fetchComments = async (page, perPage, abortSignal) => {
            try {
                const response = await getComments(page, perPage, commentableType, commentableID, abortSignal)

                if (abortSignal.aborted === false && response.length !== 0){
                    setComments(response.data);
                    setTotal(response.total);
                }

                setLoading(false);
            } catch (error) {
                showMessages(error.message, messageType.error);
                setLoading(false);
            }
        }
        fetchComments(page, perPage, abortSignal)
        if (refreshComments === true) {
            setRefreshComments(false)
        }
    }, [commentableType, commentableID, refreshComments, page, perPage])


    const onChange = (page, perPage) => {
        setPage(page);
        setPerPage(perPage);
    }

    return (
        <>
        <Spin spinning={loading}>
            {
                showCommentEditor ?
                    <>
                        <Editor onChange={onEditorChange}/>
                        <Button type="primary" onClick={onEditorSubmit} className="comment-submit-button">
                            Submit
                        </Button>
                        <Button danger onClick={onEditorCancel}>
                            Cancel
                        </Button>
                    </>
                :
                <Button onClick={onClickAddComment} type="primary">Add Comment</Button>
            }
            <CommentList comments={comments}/>
            {
                total > 0 &&
                <Pagination
                    className="paginator-stepper"
                    current={page}
                    pageSize={perPage}
                    total={total}
                    showSizeChanger={true}
                    onChange={onChange}
                    onShowSizeChange={onChange}
                    defaultCurrent={1}
                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                />
            }
        </Spin>
        </>
    )
}

Comments.propTypes = {
    commentableType: PropTypes.string.isRequired,
    commentableID: PropTypes.number.isRequired,
};

export default Comments;

